"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _UiContext = _interopRequireDefault(require("../../context/UiContext"));
var _Local = _interopRequireDefault(require("./Local.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Local = props => {
  const css = (0, _Local.default)();
  const [ui] = (0, _react.useContext)(_UiContext.default);
  const {
    _showLocals
  } = ui;
  const {
    identifier,
    l,
    ...rest
  } = props;
  if (!identifier || !l) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  if (process.env.NODE_ENV === "development" && _showLocals) {
    return /*#__PURE__*/_react.default.createElement("span", _extends({
      className: (0, _clsx.default)(css.local, "mco-local"),
      contentEditable: true,
      dangerouslySetInnerHTML: {
        __html: l(identifier, {
          ...rest
        })
      },
      onClick: e => {
        e.preventDefault();
        e.stopPropagation();
      }
    }, rest));
  }
  return /*#__PURE__*/_react.default.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: l(identifier, {
        ...rest
      })
    }
  });
};
var _default = exports.default = Local;